import React from 'react'
import styled from 'styled-components'
import Layout from '../components/layout'
import Seo from '../components/seo'
import { AutoContainer } from '../components/common'

const TermsWrapper = styled.div`
  margin-top: 80px;
  margin-bottom: 80px;
  font-size: 18px;

  h2 {
    font-weight: 600;
    font-size: 28px;
    padding-bottom: 10px;
  }

  h3 {
    font-weight: 600;
    font-size: 24px;
    padding-bottom: 10px;
  }

  h4 {
    font-weight: 600;
    font-size: 20px;
    padding-bottom: 10px;
  }

  h5 {
    font-weight: 600;
    font-size: 18px;
    padding-bottom: 10px;
  }

  ul {
    padding-left: 60px;
    font-size: 18px;
    padding-bottom: 10px;

    li {
      list-style: outside;
    }
  }

  span {
    display: block;
    padding-bottom: 20px;
  }
`

const Terms = () => (
  <AutoContainer>
    <TermsWrapper>
      <span>Last updated: May 25, 2020</span>
      <p>
        Please read these terms and conditions carefully before using Our
        Service.
      </p>
      <h2>Interpretation and Definitions</h2>
      <h3>Interpretation</h3>
      <p>
        The words of which the initial letter is capitalized have meanings
        defined under the following conditions. The following definitions shall
        have the same meaning regardless of whether they appear in singular or
        in plural.
      </p>
      <h3>Definitions</h3>
      <p>For the purposes of these Terms and Conditions:</p>
      <ul>
        <li>
          Affiliate means an entity that controls, is controlled by or is under
          common control with a party, where "control" means ownership of 50% or
          more of the shares, equity interest or other securities entitled to
          vote for election of directors or other managing authority.
        </li>
        <li>
          Company (referred to as either "the Company", "We", "Us" or "Our" in
          this Agreement) refers to Kaira Luchi LLC, Ellicott City.
        </li>
        <li>Country refers to: Maryland, United States</li>
        <li>
          Device means any device that can access the Service such as a
          computer, a cellphone or a digital tablet.
        </li>
        <li>Service refers to the Website.</li>
        <li>
          Terms and Conditions (also referred as "Terms") mean these Terms and
          Conditions that form the entire agreement between You and the Company
          regarding the use of the Service. This Terms and Conditions agreement
          has been created with the help of the Terms and Conditions Generator.
        </li>
        <li>
          Third-party Social Media Service means any services or content
          (including data, information, products or services) provided by a
          third-party that may be displayed, included or made available by the
          Service.
        </li>
        <li>
          Website refers to Kaira Luchi, accessible from
          https://www.kairaluchi.com
        </li>
        <li>
          You means the individual accessing or using the Service, or the
          company, or other legal entity on behalf of which such individual is
          accessing or using the Service, as applicable.
        </li>
      </ul>
      <h3>Acknowledgement</h3>
      <p>
        These are the Terms and Conditions governing the use of this Service and
        the agreement that operates between You and the Company. These Terms and
        Conditions set out the rights and obligations of all users regarding the
        use of the Service. Your access to and use of the Service is conditioned
        on Your acceptance of and compliance with these Terms and Conditions.
        These Terms and Conditions apply to all visitors, users and others who
        access or use the Service. By accessing or using the Service You agree
        to be bound by these Terms and Conditions without limitation or
        qualification. If You disagree with any part of these Terms and
        Conditions then You are not allowed to use this Website and should
        immediately terminate such usage. Your access to and use of the Service
        is also conditioned on Your acceptance of and compliance with the
        Privacy Policy of the Company. Our Privacy Policy describes Our policies
        and procedures on the collection, use and disclosure of Your personal
        information when You use the Application or the Website and tells You
        about Your privacy rights and how the law protects You. Please read Our
        Privacy Policy carefully before using Our Service.
      </p>
      <h3>Copyright</h3>
      <p>
        The copyright in all materials, features and functionality on the Site,
        including, but not limited to, text, graphics, videos, audio recordings,
        software, algorithms, artwork, interfaces, photographs, logos, icons,
        and images and the selection and arrangement thereof along with any
        enhancements to or derivative works thereto (collectively, "Content"),
        is the exclusive property of the Company or its licensors and is
        protected by U.S. and international laws. None of the Content shall be
        copied, reproduced, republished, uploaded, posted, transmitted, or
        distributed in any way, including, but not limited to, electronic,
        mechanical, photocopying, recording or otherwise, without the prior
        written consent of the Company, except that You may download, display,
        and print one copy of the materials on any single computer solely for
        Your personal, non-commercial use, provided that You do not modify the
        material in any way and You keep intact all copyright, trademark, and
        other proprietary notices.
      </p>
      <h3>Trademark</h3>
      <p>
        The trademarks, service marks, logos and trade names (the "Trademarks")
        used and displayed on the Site, are registered and/or unregistered
        Trademarks of the Company. Nothing on the Site should be construed as
        granting any license or right to use any Trademark or any other of Our
        intellectual property displayed on the Site. The Trademarks and Trade
        Names belonging to the Company shall not be used in any way, including
        in advertising or publicity pertaining to distribution of Content on the
        Site, without prior written permission from Us and You shall not refer
        to or attribute any information to the Company or its licensors in any
        public medium for promotional or advertising purposes, or otherwise, or
        for the purpose of influencing a third party.
      </p>
      <h3>Users’ Comments</h3>
      <p>
        The Company does not assume any obligation to monitor the information
        that You may post on its website. You warrant that any information,
        Materials (the term “Material” is intended to cover all projects, files
        or other attachments sent to Us) or comments other than personal data,
        that You may transmit to the Company through the website does not
        infringe intellectual property rights or any other applicable law. Such
        information, Materials or comments, will be treated as non-confidential
        and non proprietary. You warrant that any information, Materials or
        comments, that You may transmit to the Company through the website do
        not affect the integrity and/or the security of the website, and in
        particular, do not contain any virus, worms, Trojan horses and other
        potentially destructive programs. By submitting any information or
        material, You give the Company an unlimited and irrevocable license to
        use, copy, execute, show, display, modify and transmit such information,
        Material or comments, including any underlying idea, concept or
        know-how, in whole or in part, in any manner or medium. The Company
        reserves the right to use such information in any way it chooses.
      </p>
      <h3>Links to Other Websites</h3>
      <p>
        Our Service may contain links to third-party web sites or services that
        are not owned or controlled by the Company. The Company has no control
        over, and assumes no responsibility for, the content, privacy policies,
        or practices of any third party web sites or services. You further
        acknowledge and agree that the Company shall not be responsible or
        liable, directly or indirectly, for any damage or loss caused or alleged
        to be caused by or in connection with the use of or reliance on any such
        content, goods or services available on or through any such web sites or
        services. We strongly advise You to read the terms and conditions and
        privacy policies of any third-party web sites or services that You
        visit.
      </p>
      <h3>Termination</h3>
      <p>
        We may terminate or suspend Your access immediately, without prior
        notice or liability, for any reason whatsoever, including without
        limitation if You breach these Terms and Conditions. Upon termination,
        Your right to use the Service will cease immediately.
      </p>
      <h3>Limitation of Liability</h3>
      <p>
        Notwithstanding any damages that You might incur, the entire liability
        of the Company and any of its suppliers under any provision of this
        Terms, and Your exclusive remedy for all of the foregoing, shall be
        limited to the amount actually paid by You through the Service. To the
        maximum extent permitted by applicable law, in no event shall the
        Company or its suppliers be liable for any special, incidental,
        indirect, or consequential damages whatsoever (including, but not
        limited to, damages for loss of profits, loss of data or other
        information, for business interruption, for personal injury, loss of
        privacy arising out of or in any way related to the use of or inability
        to use the Service, third-party software and/or third-party hardware
        used with the Service, or otherwise in connection with any provision of
        this Terms), even if the Company or any supplier has been advised of the
        possibility of such damages and even if the remedy fails of its
        essential purpose. Some states do not allow the exclusion of implied
        warranties or limitation of liability for incidental or consequential
        damages, which means that some of the above limitations may not apply.
        In these states, each party's liability will be limited to the greatest
        extent permitted by law.
      </p>
      <h3>"AS IS" and "AS AVAILABLE" Disclaimer</h3>
      <p>
        The Service is provided to You "AS IS" and "AS AVAILABLE" and with all
        faults and defects without warranty of any kind. To the maximum extent
        permitted under applicable law, the Company, on its own behalf and on
        behalf of its Affiliates and its and their respective licensors and
        service providers, expressly disclaims all warranties, whether express,
        implied, statutory or otherwise, with respect to the Service, including
        all implied warranties of merchantability, fitness for a particular
        purpose, title and non-infringement, and warranties that may arise out
        of course of dealing, course of performance, usage or trade practice.
        Without limitation to the foregoing, the Company provides no warranty or
        undertaking, and makes no representation of any kind that the Service
        will meet Your requirements, achieve any intended results, be compatible
        or work with any other software, applications, systems or services,
        operate without interruption, meet any performance or reliability
        standards or be error free or that any errors or defects can or will be
        corrected. Without limiting the foregoing, neither the Company nor any
        of the company's provider makes any representation or warranty of any
        kind, express or implied: (i) as to the operation or availability of the
        Service, or the information, content, and materials or products included
        thereon; (ii) that the Service will be uninterrupted or error-free;
        (iii) as to the accuracy, reliability, or currency of any information or
        content provided through the Service; or (iv) that the Service, its
        servers, the content, or e-mails sent from or on behalf of the Company
        are free of viruses, scripts, trojan horses, worms, malware, timebombs
        or other harmful components. Some jurisdictions do not allow the
        exclusion of certain types of warranties or limitations on applicable
        statutory rights of a consumer, so some or all of the above exclusions
        and limitations may not apply to You. But in such a case the exclusions
        and limitations set forth in this section shall be applied to the
        greatest extent enforceable under applicable law.
      </p>
      <h3>Indemnification</h3>
      <p>
        You hereby indemnify, defend, and hold harmless the Company and all of
        its predecessors, successors, parents, subsidiaries, affiliates,
        officers, directors, shareholders, investors, employees, agents,
        representatives and attorneys and their respective heirs, successors and
        assigns (collectively, the "Indemnified Parties") from and against any
        and all liability and costs, including, without limitation, reasonable
        attorneys' fees, incurred by any or all the Indemnified Parties in
        connection with any claim arising out of or relating to: (i) Your access
        to or use of the Site, or (ii) any breach by You of these Terms and
        Conditions or the representations, warranties, and covenants You have
        made by agreeing to these Terms and Conditions. You shall cooperate as
        fully as reasonably required in the defense of any such claim. The
        Company reserves the right, at its own expense, to assume the exclusive
        defense and control of any matter subject to indemnification by You.
      </p>
      <h3>Governing Law</h3>
      <p>
        The laws of the Country, excluding its conflicts of law rules, shall
        govern this Terms and Your use of the Service. Your use of the
        Application may also be subject to other local, state, national, or
        international laws.
      </p>
      <h3>Disputes Resolution</h3>
      If You have any concern or dispute about the Service, You agree to first
      try to resolve the dispute informally by contacting the Company.
      <h3>United States Legal Compliance</h3>
      <p>
        You represent and warrant that (i) You are not located in a country that
        is subject to the United States government embargo, or that has been
        designated by the United States government as a "terrorist supporting"
        country, and (ii) You are not listed on any United States government
        list of prohibited or restricted parties.
      </p>
      <h3>Severability and Waiver</h3>
      <h4>Severability</h4>
      <p>
        If any provision of these Terms is held to be unenforceable or invalid,
        such provision will be changed and interpreted to accomplish the
        objectives of such provision to the greatest extent possible under
        applicable law and the remaining provisions will continue in full force
        and effect.
      </p>
      <h4>Waiver</h4>
      <p>
        Except as provided herein, the failure to exercise a right or to require
        performance of an obligation under this Terms shall not effect a party's
        ability to exercise such right or require such performance at any time
        thereafter nor shall be the waiver of a breach constitute a waiver of
        any subsequent breach.
      </p>
      <h3>Translation Interpretation</h3>
      These Terms and Conditions may have been translated if We have made them
      available to You on our Service. You agree that the original English text
      shall prevail in the case of a dispute.
      <h3>Changes to These Terms and Conditions</h3>
      <p>
        We reserve the right, at Our sole discretion, to modify or replace these
        Terms at any time. If a revision is material We will make reasonable
        efforts to provide at least 30 days' notice prior to any new terms
        taking effect. What constitutes a material change will be determined at
        Our sole discretion. By continuing to access or use Our Service after
        those revisions become effective, You agree to be bound by the revised
        terms. If You do not agree to the new terms, in whole or in part, please
        stop using the website and the Service.
      </p>
      <h3>Contact Us</h3>
      <p>
        If you have any questions about these Terms and Conditions, You can
        contact Us:
      </p>
      <ul>
        <li>By email: info@kairaluchi.com</li>
      </ul>
    </TermsWrapper>
  </AutoContainer>
)

const TermsPage = props => (
  <Layout page='Terms and Condition' {...props}>
    <Seo title='Terms and Condition' description='Terms and Condition' />
    <Terms />
  </Layout>
)

export default TermsPage
